import { render, staticRenderFns } from "./basebankaccount-add.vue?vue&type=template&id=e41bc3f2&scoped=true&"
import script from "./basebankaccount-add.vue?vue&type=script&lang=js&"
export * from "./basebankaccount-add.vue?vue&type=script&lang=js&"
import style0 from "./basebankaccount-add.vue?vue&type=style&index=0&id=e41bc3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41bc3f2",
  null
  
)

export default component.exports